import React, { useState } from "react";
import "./HospitalitySignup.scss"
import { useHistory, useLocation } from 'react-router'
import config from 'react-global-configuration';
import jwt from 'jsonwebtoken';
import MenuNavbarMini from "../../../../components/Navbar/MenuNavbarMini";
import CustomInput from "../../../../components/CustomInput/CustomInput";
import CustomPhoneInput from "../../../../components/CustomInput/CustomPhoneInput";
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import MenuFooterMini from "../../../../components/Footer/MenuFooter/MenuFooterMini";
import CustomCheckbox from "../../../../components/CustomCheckbox/CustomCheckbox";
import { renderEmail } from 'postonents';
import _ from "lodash";
import VerificationEmail from "../../../../../../../../../email/VerificationEmail";
import Modal from "../../../../components/Modal/Modal";
import EmailVerifyModal from "./EmailVerifyModal/EmailVerifyModal";
import { decrypt } from "../../../../../../../../../lib/decrypt";
import MenuFooter from "../../../../components/Footer/MenuFooter/MenuFooter";
import { isValidPhoneNumber } from 'react-phone-number-input';
import { useSelector } from "react-redux";
const HospitalitySignup = () => {
    const history = useHistory()
    const location = useLocation()
    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [email, setEmail] = useState("")
    const [userName, setUserName] = useState("")
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [addressType, setAddressType] = useState("")
    const [address1, setAddress1] = useState("")
    const [address2, setAddress2] = useState("")
    const [city, setCity] = useState("")
    const [state, setState] = useState("")
    const [postalCode, setPostalCode] = useState("")
    const [country, setCountry] = useState("United Kingdom")
    const [phone, setPhone] = useState("")
    const [landline, setLandline] = useState("")
    const [errors, setErrors] = useState({
        password: "",
        email: "",
        firstName: "",
        lastName: "",
        userName: "",
        confirmPassword: "",
        addressType: "",
        address1: "",
        city: "",
        state: "",
        postalCode: "",
        country: "",
        phone: ""
    })
    const [isError, setIsError] = useState(false)
    const [isError2, setIsError2] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [rulesChecked, setRulesChecked] = useState(false);
    const [accountAvailable, setAccountAvailable] = useState(false)
    const [codes, setCodes] = useState(Array(6).fill(""));
    const [isFailedOpen, setIsFailedOpen] = useState(false)
    const [isverifyLoading, setIsVerifyLoading] = useState(false)
    const [showVerification, setShowVerification] = useState(false)

    const restaurantDataState = useSelector((state) => state.resturantData);
    const company = useSelector((state) => state.companyData.company);

    const getNationalNumber = (phone) => {
        if (!phone) return '';
        try {
            const parsed = parsePhoneNumberFromString(phone);
            return parsed ? parsed.nationalNumber : phone;
        } catch (error) {
            return phone;
        }
    };
    const validateEmail = () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;

        const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        const nameRegex = /^[A-Za-z]+([ '-][A-Za-z]+)*$/;

        const newErrors = {
            password: "",
            email: "",
            firstName: "",
            lastName: "",
            userName: "",
            confirmPassword: "",
            addressType: "",
            address1: "",
            city: "",
            state: "",
            postalCode: "",
            country: "",
            phone: ""
        };

        const trimmedFirstName = firstName.trim();
        const trimmedLastName = lastName.trim();
        const trimmedEmail = email.trim();
        const trimmedUserName = userName.trim();
        const trimmedPassword = password.trim();
        const trimmedConfirmPassword = confirmPassword.trim();
        const trimmedAddress1 = address1.trim();
        const trimmedCity = city.trim();
        const trimmedState = state.trim();
        const trimmedPostalCode = postalCode.trim();
        const trimmedPhone = phone.trim();

        // First Name
        if (trimmedFirstName === "") {
            newErrors.firstName = "*Required";
            valid = false;
        } else if (trimmedFirstName.length < 2 || !nameRegex.test(trimmedFirstName)) {
            newErrors.firstName = "Please enter a valid name";
            valid = false;
        }

        // Last Name
        if (trimmedLastName === "") {
            newErrors.lastName = "*Required";
            valid = false;
        } else if (trimmedLastName.length < 2 || !nameRegex.test(trimmedLastName)) {
            newErrors.lastName = "Please enter a valid name";
            valid = false;
        }

        // Email
        if (trimmedEmail === "") {
            newErrors.email = "*Required";
            valid = false;
        } else if (!validateEmail(trimmedEmail)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }

        // Username
        if (trimmedUserName === "") {
            newErrors.userName = "*Required";
            valid = false;
        }

        // Password
        if (trimmedPassword === "") {
            newErrors.password = "*Required";
            valid = false;
        } else if (!passwordRegex.test(trimmedPassword)) {
            newErrors.password = "Password must be at least 8 characters long, include one uppercase letter, one number, and one special character.";
            valid = false;
        }

        // Confirm Password
        if (trimmedConfirmPassword === "") {
            newErrors.confirmPassword = "*Required";
            valid = false;
        } else if (trimmedConfirmPassword !== trimmedPassword) {
            newErrors.confirmPassword = "Passwords do not match";
            valid = false;
        }

        // Address
        if (trimmedAddress1 === "") {
            newErrors.address1 = "*Required";
            valid = false;
        }

        if (trimmedCity === "") {
            newErrors.city = "*Required";
            valid = false;
        }

        if (trimmedState === "") {
            newErrors.state = "*Required";
            valid = false;
        }

        if (trimmedPostalCode === "") {
            newErrors.postalCode = "*Required";
            valid = false;
        }

        // Phone
        if (trimmedPhone === "") {
            newErrors.phone = "*Required";
            valid = false;
        } else if (!isValidPhoneNumber(trimmedPhone)) {
            newErrors.phone = "Please enter a valid phone number";
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };


    const handleChange = (name) => {
        setErrors({
            ...errors,
            [name]: "",
        });
    };

    const handleRegister = () => {

        var secondAddresss = {
            FirstName: firstName,
            LastName: lastName,
            UserName: userName,
            Password: password,
            Email: sessionStorage.getItem("tmpEmail"),
            Avatar: "",
            OriginatedOrganizationID: config.get("OrganisationID"),
            Addresses: [
                {
                    AddressType: addressType,
                    AddressLine1: address1,
                    AddressLine2: address2,
                    City: city,
                    StateProvinceRegion: state,
                    PostZipCode: postalCode,
                    Country: country,
                    Phone: getNationalNumber(phone),
                    Fax: landline,
                    Email: "",
                    CreatedDate: Date.now,
                    LastModifiedDate: Date.now,
                },
            ],
        };
        const requestOptions = {
            method: "POST",
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                Authorization: `Bearer ` + config.get("LoginAuthorizationKey"),
            },
            body: JSON.stringify(secondAddresss),
        };

        const requestEUserDtlsOptions = {
            method: "POST",
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                Authorization: `Bearer ` + config.get("LoginAuthorizationKey"),
            },
            body: JSON.stringify({
                Email: sessionStorage.getItem("tmpEmail").toLowerCase(),
                OrganizationID: config.get("OrganisationID"),
            }),
        };

        fetch(config.get("API_URL_cust") + "globalfind", requestEUserDtlsOptions)
            .then((response) => response.json())
            .then(function (eudata) {

                if (eudata.Status) {

                    var secondAddresss = {
                        FirstName: firstName,
                        LastName: lastName,
                        UserName: userName,
                        Password: password,
                        Email: sessionStorage.getItem("tmpEmail"),
                        Avatar: "",
                        UserID: eudata.Result,
                        OriginatedOrganizationID: config.get("OrganisationID"),
                        Addresses: [
                            {
                                AddressType: addressType,
                                AddressLine1: address1,
                                AddressLine2: address2,
                                City: city,
                                StateProvinceRegion: state,
                                PostZipCode: postalCode,
                                Country: country,
                                Phone: getNationalNumber(phone),
                                Fax: landline,
                                Email: "",
                                CreatedDate: Date.now,
                                LastModifiedDate: Date.now,
                            },
                        ],
                    };
                    const requestJoinOptions = {
                        method: "POST",
                        headers: {
                            "Access-Control-Allow-Origin": "*",
                            "Content-Type": "application/json",
                            Authorization: `Bearer ` + config.get("LoginAuthorizationKey"),
                        },
                        body: JSON.stringify(secondAddresss),
                    };

                    fetch(config.get("API_URL_cust") + "join", requestJoinOptions)
                        .then((response) => response.json())
                        .then(function (data2) {
                            sessionStorage.setItem("AccessToken", data2.Result.AccessToken);
                            sessionStorage.setItem(
                                "RefreshToken",
                                data2.Result.RefreshToken
                            );
                            localStorage.setItem("isLogged", "true")
                            const expireTime =
                                new Date().getTime() + config.get("CustjwtExp") * 1000;

                            var payload = {
                                aud: config.get("CustjwtAud"),
                                exp: expireTime,
                                iss: config.get("CustjwtIss"),
                                usertoken: data2.Result.AccessToken,
                            };

                            var signOptions = {
                                algorithm: "RS256",
                            };

                            var privateKey = config.get("LoginprivateKey");
                            var token = jwt.sign(payload, privateKey, signOptions);

                            const requestUserDtlsOptions = {
                                method: "POST",
                                headers: {
                                    "Access-Control-Allow-Origin": "*",
                                    "Content-Type": "application/json",
                                    Authorization: `Bearer ` + token,
                                },
                                body: JSON.stringify({
                                    Email: sessionStorage.getItem("tmpEmail").toLowerCase(),
                                    OrganizationID: config.get("OrganisationID"),
                                }),
                            };

                            fetch(
                                config.get("API_URL_cust") + "fetch",
                                requestUserDtlsOptions
                            )
                                .then((response) => response.json())
                                .then(function (data) {

                                    sessionStorage.setItem("username", data.Result.UserName);
                                    sessionStorage.setItem(
                                        "userfirstname",
                                        data.Result.FirstName
                                    );
                                    sessionStorage.setItem(
                                        "userlastname",
                                        data.Result.LastName
                                    );
                                    sessionStorage.setItem("useremail", userName);
                                    sessionStorage.setItem("UserID", data.Result.UserID);
                                    sessionStorage.setItem(
                                        "OriginatedOrganizationID",
                                        data.Result.OriginatedOrganizationID
                                    );
                                    localStorage.setItem("isLogged", "true")
                                    localStorage.setItem(
                                        "fullUserDetails",
                                        JSON.stringify(data.Result)
                                    );
                                    setIsLoading(false)
                                    setIsSuccess(true)
                                    setIsVerifyLoading(false)
                                    setShowVerification(false)
                                });
                        });
                } else {
                    fetch(config.get("API_URL_cust") + "add", requestOptions)
                        .then((response) => response.json())
                        .then(function (data) {

                            if (data.Status === false) {
                                setIsLoading(false)
                                setIsError(true)
                                setIsVerifyLoading(false)
                                setShowVerification(false)
                            } else if (
                                data.Result ==
                                "Customer Already Exist in Global. Cannot insert again"
                            ) {
                                setIsLoading(false)
                                setIsError2(true)
                                setIsVerifyLoading(false)
                                setShowVerification(false)
                            } else {
                                sessionStorage.setItem(
                                    "AccessToken",
                                    data.Result.AccessToken
                                );
                                sessionStorage.setItem(
                                    "RefreshToken",
                                    data.Result.RefreshToken
                                );
                                sessionStorage.setItem("loggedin", "true");
                                localStorage.setItem("isLogged", "true")
                                const expireTime =
                                    new Date().getTime() + config.get("CustjwtExp") * 1000;

                                var payload = {
                                    aud: config.get("CustjwtAud"),
                                    exp: expireTime,
                                    iss: config.get("CustjwtIss"),
                                    usertoken: data.Result.AccessToken,
                                };

                                var signOptions = {
                                    algorithm: "RS256",
                                };

                                var privateKey = config.get("LoginprivateKey");
                                var token = jwt.sign(payload, privateKey, signOptions);

                                const requestUserDtlsOptions = {
                                    method: "POST",
                                    headers: {
                                        "Access-Control-Allow-Origin": "*",
                                        "Content-Type": "application/json",
                                        Authorization: `Bearer ` + token,
                                    },
                                    body: JSON.stringify({
                                        Email: sessionStorage.getItem("tmpEmail").toLowerCase(),
                                        OrganizationID: config.get("OrganisationID"),
                                    }),
                                };

                                fetch(
                                    config.get("API_URL_cust") + "fetch",
                                    requestUserDtlsOptions
                                )
                                    .then((response) => response.json())
                                    .then(function (data) {

                                        sessionStorage.setItem("username", data.Result.UserName);
                                        sessionStorage.setItem(
                                            "userfirstname",
                                            data.Result.FirstName
                                        );
                                        sessionStorage.setItem(
                                            "userlastname",
                                            data.Result.LastName
                                        );
                                        sessionStorage.setItem("useremail", userName);
                                        sessionStorage.setItem("UserID", data.Result.UserID);
                                        sessionStorage.setItem(
                                            "OriginatedOrganizationID",
                                            data.Result.OriginatedOrganizationID
                                        );
                                        localStorage.setItem("isLogged", "true")

                                        localStorage.setItem(
                                            "fullUserDetails",
                                            JSON.stringify(data.Result)
                                        );
                                        setIsLoading(false)
                                        setIsSuccess(true)
                                        setIsVerifyLoading(false)
                                        setShowVerification(false)
                                    });
                            }
                        });
                }
            });

    };
    const encrypt = (data) => {
        var CryptoJS = require("crypto-js");
        var key = 'U2FsdGVkX1y3pF1AfoHaMGdUJpg6nOMru98BUt';
        var cipherText = CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
        return cipherText;
    }
    const handleValidateEmail = () => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                Authorization: `Bearer ` + config.get('LoginAuthorizationKey'),
            },
            body: JSON.stringify({ "Email": email, "OrganizationID": config.get('OrganisationID') })
        };
        fetch(config.get('API_URL_cust') + 'find', requestOptions)
            .then(response => response.json())
            .then(function (data) {
                if (data.Status === false) {
                    sessionStorage.setItem('tmpEmail', email);


                    let DigitCode = _.random(100000, 999999);
                    let token = encrypt(JSON.stringify(DigitCode));

                    const data = {
                        verificationToken: token,
                        companyPageTitle: config.get('companyPageTitle'),
                        SenderEmail: config.get('SenderEmail'),
                        companyLogoCDN: config.get('companyLogoCDN'),
                        DigitCode: DigitCode,
                        email: email
                    }
                    const emailBody = renderEmail(VerificationEmail, { lang: 'en', data });

                    sessionStorage.setItem('verificationtoken', token);
                    sessionStorage.setItem('tmpEmail', email);

                    async function postData() {
                        const ecoEmail = {
                            "to": email,
                            "from": config.get('companyPageTitle') + "<" + config.get('SenderEmail') + ">",
                            "subject": "Your verification code",
                            "html": emailBody
                        };
                        const response = await fetch(config.get('backendURL') + 'mail/send', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(ecoEmail)
                        })
                        return response.json();
                    }

                    postData()
                        .then(data => {
                            if (data === "SUCCESS") {
                                setShowVerification(true)
                            }
                            else {
                                setIsLoading(false)
                                setIsError(true)
                            }
                        });
                } else {
                    setIsLoading(false)
                    setAccountAvailable(true)
                }
            })
    };

    const onVerify = () => {
        const initialValues = JSON.parse(decrypt(decodeURIComponent(sessionStorage.getItem('verificationtoken'))))
        setIsVerifyLoading(true)
        let code = Number(codes.join(''))
        if (code === initialValues) {
            sessionStorage.setItem('regeligible', true);
            handleRegister()
        }
        else {
            setCodes(Array(6).fill(""))
            setIsLoading(false)
            setIsFailedOpen(true);
            setIsVerifyLoading(false)
            setShowVerification(false)
        }

    };
    return (
        <div className="HospitalitySignup"
            style={{ backgroundColor: config.get('Theme') === 'Hospitality-Default-V3-REGAL' ? company?.Style?.BackgroundColor : "" }}

        >
            <MenuNavbarMini />
            <div className="HospitalitySignup-header">
                Create Your Account
            </div>
            <div className="HospitalitySignup-wrapper">

                <div className="signup-input-container-wrapper">
                    <div className="signup-input-container-wrapper-header">
                        Account Information
                    </div>
                    <div className="signup-input-container-wrapper-flex">
                        <CustomInput
                            onChange={(e) => {
                                setEmail(e.target.value);
                                handleChange("email")
                            }}
                            value={email}
                            error={errors.email !== ""}
                            errorText={errors.email}
                            label={"Email Address"}
                            required
                            icon={"email"}
                            placeholder={"Enter your email address"}
                        />
                        <CustomInput
                            onChange={(e) => {
                                setUserName(e.target.value);
                                handleChange("userName")
                            }}
                            value={userName}
                            error={errors.userName !== ""}
                            errorText={errors.userName}
                            label={"Username"}
                            required
                            icon={"user"}
                            placeholder={"Enter your username"}
                        />
                    </div>
                </div>
                <div className="signup-input-container-wrapper">
                    <div className="signup-input-container-wrapper-header">
                        Personal Information
                    </div>
                    <div className="signup-input-container-wrapper-flex">
                        <CustomInput
                            onChange={(e) => {
                                setFirstName(e.target.value);
                                handleChange("firstName")
                            }}
                            value={firstName}
                            error={errors.firstName !== ""}
                            errorText={errors.firstName}
                            label={"First Name"}
                            required
                            icon={"user"}
                            placeholder={"Enter your first name"}
                        />
                        <CustomInput
                            onChange={(e) => {
                                setLastName(e.target.value);
                                handleChange("lastName")
                            }}
                            value={lastName}
                            error={errors.lastName !== ""}
                            errorText={errors.lastName}
                            label={"Last Name"}
                            required
                            icon={"user"}
                            placeholder={"Enter your last name"}
                        />
                    </div>
                    <div className="signup-input-container-wrapper-flex">
                        <CustomInput
                            onChange={(e) => {
                                setPassword(e.target.value);
                                handleChange("password")
                            }}
                            value={password}
                            error={errors.password !== ""}
                            errorText={errors.password}
                            label={"Password"}
                            required
                            icon={"lock"}
                            placeholder={"Enter your password"}
                            type="password"
                        />
                    </div>
                    <div className="signup-input-container-wrapper-flex">
                        <CustomInput
                            onChange={(e) => {
                                setConfirmPassword(e.target.value);
                                handleChange("confirmPassword")
                            }}
                            value={confirmPassword}
                            error={errors.confirmPassword !== ""}
                            errorText={errors.confirmPassword}
                            label={"Confirm Password"}
                            required
                            icon={"lock"}
                            placeholder={"Re-enter your password"}
                            type="password"

                        />
                    </div>
                    <div className="signup-input-container-wrapper-flex">
                        <CustomPhoneInput
                            required
                            label={"Phone Number"}
                            placeholder="Enter your phone number"
                            value={phone}
                            onChange={(e) => {
                                if (e === undefined) {
                                    setPhone("")
                                } else {
                                    setPhone(e)
                                }
                                handleChange("phone")

                            }}
                            error={errors.phone !== ""}
                            errorText={errors.phone}

                        />
                    </div>
                </div>
                <div className="signup-input-container-wrapper">
                    <div className="signup-input-container-wrapper-header">
                        Address Information
                    </div>
                    <div className="signup-input-container-wrapper-flex">
                        <CustomInput
                            onChange={(e) => {
                                setAddress1(e.target.value);
                                handleChange("address1")
                            }}
                            value={address1}
                            error={errors.address1 !== ""}
                            errorText={errors.address1}
                            label={"Address Line 1"}
                            required
                            icon={"address"}
                            placeholder={"Enter your address"}
                        />
                    </div>
                    <div className="signup-input-container-wrapper-flex">
                        <CustomInput
                            onChange={(e) => {
                                setAddress2(e.target.value);
                                handleChange("address2")
                            }}
                            value={address2}
                            label={"Address Line 2 (Optional)"}
                            placeholder={"Apt, suite, or other (optional)"}
                        />
                    </div>
                    <div className="signup-input-container-wrapper-flex">
                        <CustomInput
                            onChange={(e) => {
                                setCity(e.target.value);
                                handleChange("city")
                            }}
                            value={city}
                            error={errors.city !== ""}
                            errorText={errors.city}
                            label={"City"}
                            required
                            placeholder={"Enter your city"}
                        />
                        <CustomInput
                            onChange={(e) => {
                                setState(e.target.value);
                                handleChange("state")
                            }}
                            value={state}
                            error={errors.state !== ""}
                            errorText={errors.state}
                            label={"State/Province"}
                            required
                            placeholder={"Enter your state or province"}
                        />
                    </div>
                    <div className="signup-input-container-wrapper-flex">
                        <CustomInput
                            onChange={(e) => {
                                setPostalCode(e.target.value);
                                handleChange("postalCode")
                            }}
                            value={postalCode}
                            error={errors.postalCode !== ""}
                            errorText={errors.postalCode}
                            label={"Postal/ZIP Code"}
                            required
                            placeholder={"Enter your state postal/zip code"}
                        />
                        <CustomInput
                            value={country}
                            label={"Country"}
                            placeholder={"Enter your country"}
                            disable
                        />
                    </div>
                </div>
                <div className="signup-bottom">
                    <div className="signup-terms">
                        <CustomCheckbox checked={rulesChecked} onChange={() => { setRulesChecked(!rulesChecked) }} />
                        <div className="signup-text">
                            I agree to the <span>Terms and Conditions</span> and <span>Privacy Policy</span>
                        </div>
                    </div>
                    <div className={`signup-chackout-btn ${!rulesChecked ? "disabled" : ""}`}
                        onClick={() => {
                            if (rulesChecked) {

                                if (validateForm() && !isLoading) {
                                    setIsLoading(true)
                                    handleValidateEmail()
                                }
                            }
                        }}>
                        {isLoading && <div className="loader-btn " />}
                        Create Account
                    </div>
                </div>

            </div>
            <Modal visibility={accountAvailable} type="failed" headerText="You have already an account with us" subText="Please login to continue the shopping" onPopupClose={() => {
                setAccountAvailable(false);
            }} />
            <EmailVerifyModal
                visibility={showVerification}
                onPopupClose={() => {
                    setIsLoading(false)
                    setShowVerification(false)
                }}
                setIsFailedOpen={setIsFailedOpen}
                setIsVerifyLoading={setIsVerifyLoading}
                codes={codes}
                setCodes={setCodes}
                isVerifyLoading={isverifyLoading}
                onVerify={onVerify}
            />
            <Modal visibility={isFailedOpen} type="failed" headerText="The email verification code is invalid" subText="Did you recently request an account without verifying your email address? If your email address has not been verified, you may need to create a new account. If you are having trouble, see Account Help." onPopupClose={() => {
                setIsFailedOpen(false);
                setIsLoading(false)
            }} />
            <Modal visibility={isError} type="failed" headerText="Oops!! Something wrong" subText={`We are sorry, Something wrong with the registration process. Please try again later.'`} onPopupClose={() => { setIsError(false) }} />
            <Modal visibility={isSuccess} type="success" headerText="Account registration success" subText="Click ok to continue to your account" onPopupClose={() => {
                if (location?.state?.from === "home") {
                    history.push("/")
                } else {
                    let vouchersAvailable = restaurantDataState.orderCartData?.Items?.some(itemVal => !itemVal?.MetaData && itemVal?.MetaData?.IsVoucher) ?? false;
                    if (vouchersAvailable) {
                        history.push("/order/checkout-voucher")
                    } else {
                        history.push("/order/checkout")

                    }
                }
            }} />
            <MenuFooter />
        </div>
    )
}
export default HospitalitySignup